<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Bookings</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                  <div class="card-content h-100" style="overflow:auto">
                    <div class="row filter-cls">
                      <div class="search-input col s5 m5 l5">
                        <div class="sidebar-search animate fadeUp">
                          <div class="search-area">
                            <i class="material-icons mr-2 search-icon">search</i>
                            <i class="material-icons mr-2 close-icon" @click="reset(1,$event)">close</i>
                            <input
                              type="text"
                              autocomplete="off"
                              v-model="searchText"
                              placeholder="Search by booking id"
                              class="app-filter"
                              id="chat_filter"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col s3 m3 l3">
                        <div class="input-field">
                          <i class="material-icons mr-2 close-icon" @click="reset(2,$event)">close</i>
                          <input name="date" class="datepicker" id="datepicker" type="text" />
                          <label for="datepicker" class>Filter by date</label>
                        </div>
                      </div>
                      <div class="col s4 m4 l4">
                        <div class="input-field">
                          <i class="material-icons mr-2 close-icon" @click="reset(3,$event)">close</i>
                          <input
                            autocomplete="off"
                            type="text"
                            id="autocomplete-input"
                            class="autocomplete"
                          />
                          <label for="autocomplete-input">Filter by status</label>
                        </div>
                      </div>
                    </div>
                    <div class="row booking-block" style="height: calc(100% - 80px)">
                      <div class="col s12 l12 m12 block-overflow" style="height:100%">
                        <div
                          class="card-view row"
                          v-for="(booking,index) in bookingList.results"
                          :key="booking.uid"
                        >
                          <div class="col s9 m9 l9 p-0">
                            <div class="card-view-content pointer" @click="selectbooking(booking)">
                              <div class="indicator"></div>
                              <div class="text-content">
                                <div class="label-status">
                                  <span class="classtag">{{booking.uid}}</span>
                                  <span class="prioritytag">{{booking.service}}</span>
                                </div>
                                <div class="inn-cont">
                                  <div
                                    class="owner"
                                  >{{booking.user ? booking.user.first_name : "-"}}</div>
                                  <div class="created_at">{{booking.created_at | relativeTime}}</div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <span
                                v-if="booking.dates"
                                :class="getClassName(booking)"
                              >{{booking.dates ? (booking.dates.status ? booking.dates.status.name : "") : ""}}</span>
                            </div>
                          </div>
                          <div class="col s3 m3 l3">
                            <div class="assignee-block col l6">
                              <div class="assignee-title">Assignee</div>
                              <div class="assignee" v-if="booking.vendor">
                                <b>{{booking.vendor ? booking.vendor.first_name : ""}}({{booking.vendor ? booking.vendor.rep_id : ""}})</b>
                              </div>
                              <div class="assignee" v-if="!booking.vendor">No one</div>
                              <!-- <i
                                v-if="!booking.vendor && isAssigneeShow(booking)"
                                @click="openAssignees($event,booking,index)"
                                class="material-icons a-settings"
                                :class="[`setting-${index}`]"
                                data-toggle="popover"
                                data-container="body"
                                data-placement="top"
                                :data-content="getTemplate"
                                data-html="true"
                              >settings</i>-->
                            </div>
                            <div class="assignee-settings col l6">
                              <popper
                                trigger="click"
                                :options="{placement: 'bottom'}"
                                :ref="`popper-${index}`"
                              >
                                <div class="assignees-list popper">
                                  <div class="assignees input-search-box search-input">
                                    <div class="assignees search-area">
                                      <i class="assignees material-icons mr-2 search-icon">search</i>
                                      <input
                                        type="text"
                                        placeholder="Search assignees"
                                        :id="'assignee_filter'+ index"
                                        class="assignees app-filter assignee_filter"
                                        v-model.trim="assigneeSearch"
                                        @keydown.enter="searchAssignee"
                                      />
                                    </div>
                                  </div>
                                  <div class="assignees list-opts">
                                    <div class="loader" v-if="assigneeLoader">
                                      <svg
                                        version="1.1"
                                        id="L9"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 100 100"
                                        enable-background="new 0 0 0 0"
                                        xml:space="preserve"
                                      >
                                        <path
                                          fill="#cdefd0"
                                          d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                                        >
                                          <animateTransform
                                            attributeName="transform"
                                            attributeType="XML"
                                            type="rotate"
                                            dur="1s"
                                            from="0 50 50"
                                            to="360 50 50"
                                            repeatCount="indefinite"
                                          />
                                        </path>
                                      </svg>
                                    </div>
                                    <div class="assingee-block" v-if="!assigneeLoader">
                                      <div
                                        v-if="assigneeList.length==0"
                                        class="assignees-list-items"
                                      >
                                        <div
                                          class="uname center-align"
                                          style="width:100%"
                                        >No vendors found</div>
                                      </div>
                                      <div
                                        class="assignees-list-items"
                                        @click="selectAssignee(assignee,index)"
                                        v-for="(assignee,vIndex) in assigneeList"
                                        :key="vIndex"
                                      >
                                        <div
                                          class="assignees usr-img"
                                        >{{assignee.vendor.short_name}}</div>
                                        <div class="assignees uname">{{assignee.vendor.first_name}}</div>
                                        <div
                                          class="assignees fullname"
                                          v-if="assignee.vendor"
                                        >{{assignee.vendor ? (assignee.vendor.rep_id + ",") : ""}}</div>
                                        <div
                                          class="assignees distance"
                                        >{{assignee.distance | number}} km away</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <a
                                  slot="reference"
                                  class="top"
                                  v-if="!booking.vendor && isAssigneeShow(booking)"
                                >
                                  <i
                                    @click="openAssignees($event,booking)"
                                    class="material-icons a-settings"
                                    :class="[`setting-${index}`]"
                                  >settings</i>
                                </a>
                              </popper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  data() {
    return {
      bookingList: {
        results: [],
        count: 0,
        previous: null,
        next: null
      },
      assigneeList: [],
      currbooking: "",
      searchText: "",
      filters: {
        date: "",
        status: ""
      },
      isLoader: true,
      assigneeLoader: false,
      isLazyLoading: true,
      statusList: [
        "Payment Failed",
        "Service Booked",
        "Service Started",
        "Service Completed",
        "Service Cancelled",
        "Vendor Declined"
      ],
      assigneeSearch: "",
      assigneeAllList:[]
    };
  },
  components: {
    popper: Popper
  },
  async created() {
    var thisObj = this;
    setTimeout(() => {
      $(".block-overflow").on("scroll", async e => {
        var docheight = e.target.scrollHeight - e.target.clientHeight;
        var scrollTop = e.target.scrollTop;
        var pctScrolled = Math.floor((scrollTop / docheight) * 100);
        if (thisObj.bookingList.next) {
          if (pctScrolled >= 90 && this.isLazyLoading == true) {
            this.isLazyLoading = false;
            await thisObj.listbookings(thisObj.bookingList.next, true);
            this.isLazyLoading = true;
          }
        }
      });
      let opts = {
        onSelect: e => {
          this.filters.date = e;
          this.searchFilter(this.filters);
          $("i.close-icon")
            .eq(1)
            .show();
          M.updateTextFields();
        },
        autoClose: true
      };
      window.instance = M.Datepicker.init(
        document.querySelectorAll(".datepicker"),
        opts
      );
      setTimeout(() => {
        $(".datepicker").on("focusin", e => {
          if (instance[0] && !instance[0].isOpen) {
            instance[0].open();
          }
        });
      }, 100);

      // $("html")
      //   .off()
      //   .on("click", function(e) {
      //     if (
      //       !$(e.target).hasClass("a-settings") &&
      //       !$(e.target).hasClass("popover") &&
      //       $(e.target)
      //         .attr("class")
      //         .indexOf("assignees") == -1
      //     ) {
      //       $('[data-toggle="popover"]').popover("hide");
      //     }
      //   });
      this.onInitFunc();
    }, 500);
    setTimeout(() => {
      try {
        notificationHub.$on("received", payload => {
          thisObj.onInitFunc();
        });
      } catch (error) {}
    }, 100);
  },
  methods: {
    onInitFunc() {
      this.listbookings();
      this.listStatus();
    },
    listbookings(url = Constants.default.APIURL.Bookings, status = false) {
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            let temp = this.bookingList;

            if (status) {
              let temp = this.bookingList.results;
              this.bookingList = {
                count: res.data.count,
                previous: res.data.previous,
                next: res.data.next
              };
              this.bookingList.results = temp.concat(res.data.results);
            } else {
              this.bookingList = res.data;
            }

            setTimeout(() => {
              this.isLoader = false;
              if (this.bookingList.results.length == 0) {
                Vue.showNoDataBlock(".booking-block");
              } else {
                Vue.hideNoDataBlock(".booking-block");
              }
            }, 500);
            resolve(true);
          },
          err => {
            this.isLoader = false;
            resolve(false);
          }
        );
      });
    },
    async searchFilter(filter) {
      let queryStr = "?q=" + (this.searchText || "");
      queryStr +=
        "&dates__date=" +
        (filter.date ? new Date(filter.date + "z").toJSON().split("T")[0] : "");
      queryStr += "&dates__status__name=" + (filter.status || "");
      let url = Constants.default.APIURL.Bookings + queryStr;
      await this.listbookings(url);
    },
    openAssignees(ev, booking, i) {
      this.currbooking = booking;
      this.listAssignees(
        Constants.default.APIURL.RelatedVendors + this.currbooking.uid
      );
    },
    selectbooking(booking) {
      this.$router.push({ path: "/app/booking-detail/" + booking.uid });
    },
    listAssignees(url) {
      this.assigneeLoader = true;
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            this.assigneeAllList = res.data;
            this.assigneeList = JSON.parse(JSON.stringify(this.assigneeAllList))
            this.assigneeLoader = false;
            resolve(true);
          },
          err => {
            this.assigneeLoader = false;
            resolve(false);
          }
        );
      });
    },
    listStatus() {
      return new Promise(resolve => {
        let data = {};
        this.statusList.forEach(val => {
          data[val] = null;
        });
        let opts = {
          data: data,
          minLength: 0,
          onAutocomplete: text => {
            let item = this.statusList.find(val => {
              return val == text;
            });
            this.filters.status = item;
            this.searchFilter(this.filters);
            $("i.close-icon")
              .eq(2)
              .show();
            M.updateTextFields();
          }
        };
        $(".autocomplete").on("keyup", e => {
          if (!e.target.value) {
            this.filters.status = "";
            $("i.close-icon")
              .eq(2)
              .hide();
            this.searchFilter(this.filters);
          }
        });
        setTimeout(() => {
          window.autocompleteInstance = M.Autocomplete.init(
            document.querySelectorAll(".autocomplete"),
            opts
          );
          setTimeout(() => {
            $(".autocomplete").on("focusin", e => {
              if (autocompleteInstance[0] && !autocompleteInstance[0].isOpen) {
                setTimeout(() => {
                  autocompleteInstance[0].open();
                }, 100);
              }
            });
          }, 100);
        }, 300);
        resolve(true);
      });
    },
    selectAssignee(assignee, i) {
      let query = {
        vendor: assignee.vendor.id
      };
      ajax.patch(
        Constants.default.APIURL.AssignVendor + this.currbooking.uid,
        query,
        res => {
          this.$refs[`popper-${i}`][0].doClose();
          Vue.toast("Booking has been assigned successfully.");
          this.listbookings();
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    reset(type, ev) {
      if (type == 1) {
        this.searchText = "";
      } else if (type == 2) {
        this.filters.date = "";
      } else {
        this.filters.status = "";
      }
      $(ev.target)
        .closest("div")
        .children()
        .each((key, dom) => {
          if (dom.tagName == "INPUT") {
            dom.value = "";
          }
        });
      setTimeout(() => {
        $(ev.target).hide();
        M.updateTextFields();
      }, 200);
      this.searchFilter(this.filters);
    },
    isAssigneeShow(item) {
      let isCancel =
        item.dates.status.code == "service_started" ||
        item.dates.status.code == "service_completed" ||
        item.dates.status.code == "service_cancelled" ||
        item.dates.status.code == "payment_failed" ||
        item.dates.status.code == "admin_service_cancelled";
      return !isCancel;
    },
    getClassName(booking) {
      if (booking && booking.dates.status) {
        let className = "";
        if (booking.dates.status.name) {
          if (booking.dates.status.name.indexOf("Booked") != -1)
            className = "open";
          else if (booking.dates.status.name.indexOf("Started") != -1)
            className = "inprogress";
          else if (booking.dates.status.name.indexOf("Completed") != -1)
            className = "completed";
          else className = "failed";
        }
        return "statustag " + className;
      } else return "statustag";
    },
    getServiceClass(booking) {
      if (booking.package) {
        return "servicetag";
      } else return "servicetag one-time";
    },
    searchAssignee() {
      this.assigneeList =  this.assigneeAllList.filter((a)=> a.first_name.toLowerCase().indexOf(this.assigneeSearch.toLowerCase()) != -1)
    }
  },
  watch: {
    searchText(text) {
      this.searchText = text;
      if (text) {
        $("i.close-icon")
          .eq(0)
          .show();
      } else {
        $("i.close-icon")
          .eq(0)
          .hide();
      }
      this.searchFilter(this.filters);
    }
  }
};
</script>

<style lang="scss" scoped>
.center-align {
  text-align: center;
  width: 100%;
}
.assignee-block {
  position: relative;
  text-align: left;
  top: 20px;
  .assignee-title {
    font-weight: 500;
  }
  .assignee {
    color: #183247;
    font-size: 14px;
  }
}
.assignee-settings {
  position: relative;
  top: 20px;
  a {
    color: #183247;
    i {
      cursor: pointer;
      font-size: 18px;
    }
  }
}

.assignees-list {
  min-width: 350px;
  // overflow: hidden auto;
  padding: 5px;
  box-shadow: rgb(58, 58, 58) 0 0 1px 0;
  .list-opts {
    min-height: 100px;
    .loader {
      svg {
        width: 100px;
      }
    }
  }
  .input-search-box {
    padding: 0 0 10px;
    position: sticky;
    top: 0;
    background: white;
  }
  .assignees-list-items {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 10px 0px 10px;
    min-height: 70px;
    // border-bottom: 1px solid #f1eded;
    div {
      margin: 5px;
      padding: 0px;
    }
    .usr-img {
      width: 30px;
      height: 30px;
      border-radius: 5px;
      background: #efe7e7;
    }

    .uname {
      font-weight: 600;
    }
  }
}

.filter-cls {
  .search-input {
    i.close-icon {
      display: none;
      position: absolute;
      right: 10px;
      cursor: pointer;
      font-size: 18px;
      top: 15px;
    }
  }
  .input-field {
    i.close-icon {
      position: absolute;
      display: none;
      cursor: pointer;
      right: 0;
      font-size: 18px;
      top: 15px;
    }
  }
}

.show-assignee {
  max-height: 400px;
  opacity: 1;
  margin-bottom: 100px;
}

.name-cls {
  display: inline-block;
  white-space: nowrap;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.desp {
  padding: 0 10px;
}

.filter-cls {
  .input-field {
    margin-top: 10px;
  }
}

.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    // height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
    top: 25px !important;
    position: inherit;
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #9e9e9e;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}

.card-view:hover .indicator {
  height: 100%;
  top: 0 !important;
  opacity: 1;
}

.card-view {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(220, 220, 220, 0.151);
  margin: 15px 0;
  padding: 20px;
  position: relative;
  border-radius: 3px;
  .indicator {
    position: absolute;
    height: 0;
    width: 2px;
    background: #ef0000;
    left: -1px;
    top: 50%;
    opacity: 0;
    border-radius: 5px;
    transition: 0.4s ease-in-out;
  }
  .card-view-content {
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    float: left;
    .owner {
      display: inline-block;
      font-weight: 500;
      padding-right: 6px;
      font-size: 14px;
    }
    .created_at {
      display: inline-block;
      color: #9e9e9e;
      font-size: 13px;

      &::before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #a2aab4;
        border-radius: 100%;
        margin-right: 7px;
      }
    }
    .text-content {
      line-height: 1.8;
      .label-status {
        display: inline-block;
        margin-bottom: 3px;
      }
      span {
        &.classtag {
          font-size: 15px;
          font-weight: 500;
          display: block;
        }
        &.prioritytag {
          border: 1px solid gainsboro;
          padding: 1px 10px;
          border-radius: 5px;
          font-size: 13px;
        }
      }
    }
  }
  .statustag {
    font-size: 14px;
    position: relative;
    top: 20px;
    background: #ff5a5a;
    color: #fff;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 500;
    &.inprogress {
      background: #0099ff;
      border-color: #0099ff;
    }
    &.completed {
      background: #3fa93a;
      border-color: #3fa93a;
    }
    &.failed {
      background: #e48b22;
      border-color: #e48b22;
    }
  }
}

.icon-clas {
  height: 9px;
  width: 9px;
  position: absolute;
  left: -15px;
  top: 9px;
  background: #9e9e9e;
  border-radius: 2px;
}

.icon-clas.q-cls {
  background: #ef0000;
}

.icon-clas.q-filtr {
  background: rgb(71, 131, 201);
}

.select-cards.select-cls.booking {
  position: relative;
}
.servicetag {
  border: 1px solid #82e3b2;
  padding: 1px 10px;
  border-radius: 5px;
  font-size: 13px;
  margin-left: 15px;
  background: #82e3b2;
  color: #261ba7;
  font-weight: 500;
}
.datepicker-date-display .date-text {
  font-size: 20px;
}
</style>